export const translations = {
    en: {
        nav: {
            features: "Features",
            platform: "Platform",
            roadmap: "Roadmap",
            pricing: "Pricing",
            faq: "FAQ",
            contact: "Contact",
            beta: "Request Beta Access",
            signin: "Sign in"
        },
        hero: {
            badge: "BETA VERSION OUT NOW! Join the list to get access",
            title1: "<span class='word'>The</span> <span class='word'>Operating</span> <span class='word'>System</span>",
            title2: "<span class='word'>for</span> <span class='word highlight'>Industrial-Scale</span> <span class='word'>Mining</span> <span class='word'>Farms.</span>",
            desc: "<span class='desc-word'>Visualize</span> <span class='desc-word'>your</span> <span class='desc-word'>physical</span> <span class='desc-word'>infrastructure</span> <span class='desc-word'>in</span> <span class='desc-word'>real-time.</span> <span class='desc-word'>Automate</span> <span class='desc-word'>Rev-Share</span> <span class='desc-word'>distribution.</span> <span class='desc-word'>Eliminate</span> <span class='desc-word'>Excel</span> <span class='desc-word'>spreadsheets</span> <span class='desc-word'>from</span> <span class='desc-word'>your</span> <span class='desc-word'>operation.</span>"
        },
        partnership: {
            powered: "Powered by",
            partner: "In Partnership with"
        },
        stats: {
            val1: "+30%",
            lbl1: "Increase Uptime",
            val2: "500+",
            lbl2: "Sites Managed",
            val3: "50K+",
            lbl3: "Miners Monitored",
            val4: "24/7",
            lbl4: "Real-time Support"
        },
        platform: {
            title: "Your Complete Command Center",
            subtitle: "All the tools you need to monitor, manage, and optimize your mining operations in one powerful, unified platform.",
            slides: {
                dashboard: {
                    title: "Real-Time Dashboard",
                    desc: "Monitor all your mining operations from a single, intuitive interface.",
                    f1: "Live hashrate tracking across all sites",
                    f2: "Worker status monitoring (active/inactive)",
                    f3: "Bitcoin price integration",
                    f4: "Historical performance charts",
                    f5: "Site-by-site breakdown tables",
                    f6: "Auto-refresh every 10 seconds"
                },
                revshare: {
                    title: "Distribución de Ingresos (Rev-Share) en Piloto Automático.",
                    desc: "Conecta tu API de ViaBTC (Solo Lectura) y deja que MINEOPS calcule exactamente cuánto le toca a cada socio y sub-cliente. Cero errores de captura matemática, listo para facturar.",
                    f1: "Sub-cuentas automatizadas",
                    f2: "Integración nativa con ViaBTC API",
                    f3: "Elimina el error humano en cálculos",
                    f4: "Cálculos de electricidad en tiempo real",
                    f5: "Reportes listos para facturación",
                    table: {
                        partner: "Socio",
                        hashrate: "Hashrate (%)",
                        income: "Ingreso BTC",
                        status: "Estado",
                        s1: "Socio Alpha",
                        s2: "Socio Beta",
                        s3: "Inversor Fondo",
                        st_paid: "Pagado",
                        st_pending: "Pendiente",
                        rt_dist: "Distribución en Tiempo Real",
                        rt_viabtc: "Cálculos ViaBTC",
                        rt_power: "Ajuste Eléctrico"
                    }
                },
                sites: {
                    title: "Multi-Site Management",
                    desc: "Comprehensive view of all your mining locations in one place.",
                    f1: "Aggregate or individual site views",
                    f2: "Historical performance tracking",
                    f3: "Worker distribution by site",
                    f4: "Hashrate distribution pie charts",
                    f5: "Detailed worker status tables",
                    f6: "Firewall + Pool data integration"
                },
                finance: {
                    title: "Financial Analytics",
                    desc: "Complete financial overview of your mining operations.",
                    f1: "Multi-currency support (BTC, USD, MXN)",
                    f2: "Profit & loss tracking",
                    f3: "Expense management by category",
                    f4: "Investment tracking & ROI",
                    f5: "Time interval analysis (daily to all-time)",
                    f6: "Per-site financial breakdown"
                }
            }
        },
        features: {
            title: "Why Choose MineOps?",
            subtitle: "The most comprehensive mining management platform on the market",
            f1: { title: "Increase Efficiency", desc: "Reduce downtime by 40% with automated monitoring and instant alerts" },
            f2: { title: "Maximize Profits", desc: "Optimize operations and reduce costs with data-driven insights" },
            f3: { title: "Enterprise Security", desc: "Bank-level encryption and security protocols protect your data" },
            f4: { title: "Scale Effortlessly", desc: "Grow from 1 to 10,000+ miners without missing a beat" }
        },
        rack: {
            title: "Customize Your Site Racks",
            desc: "Monitor and manage your available rack spaces in real-time. Get instant visibility into all your mining sites with comprehensive statistics and performance metrics.",
            f1: "Real-time site statistics and performance metrics",
            f2: "Quick access to rack management for each site",
            f3: "Aggregated hashrate and efficiency data",
            visual: {
                title: "Mapeo Físico de Racks. Encuentra fallas en 1 segundo.",
                desc: "Pasa de listas interminables a un NOC (Network Operations Center) visual. Códigos de color térmicos y de hashrate en tiempo real. Manda a tus técnicos exactamente al rack y repisa que está fallando.",
                lbl_optimal: "Optimal:",
                st_optimal: "Working correctly.",
                lbl_warning: "Warning:",
                st_warning: "Low hashrate.",
                lbl_offline: "Offline:",
                st_offline: "Malfunctioning.",
                integration: "Integrates with ViaBTC API"
            }
        },
        roadmap: {
            title: "Coming Soon: Future Implementations",
            subtitle: "Exciting new features we're developing to take your mining operations to the next level",
            badge: "Coming Soon",
            f1: { title: "AI Analytics (Predicción de fallas)", desc: "Advanced AI algorithms developed by our professional team to predict equipment failures, optimize performance, and maximize profitability." },
            f2: { title: "Telegram Bot Alerts", desc: "Receive instant alerts about your workers directly in Telegram. Get notified about downtime, temperature issues, and performance changes." }
        },
        pricing: {
            badge: "Pricing",
            title: "Plans tailored to your Hashrate",
            subtitle: "Plans are automatically assigned based on your total Hashrate (PH/s). Enjoy the best features tailored to your operation's scale.",
            fee: "/mining fee",
            p1: { name: "Starter", desc: "For small operations — simple, transparent pricing.", limit: "0 - 20 Ph/s" },
            p2: { name: "Professional", desc: "Built for growing operations that need advanced monitoring and reporting.", limit: "20 - 50 Ph/s" },
            p3: { name: "Enterprise", desc: "Full enterprise-grade solution for large operations and bespoke integrations.", limit: "50 + Ph/s" },
            features: {
                basic_mon: "Basic monitoring",
                email_supp: "Email support",
                users_5: "5 users included",
                adv_mon: "Advanced monitoring",
                priority_supp: "Priority support",
                fin_reports: "Financial reports",
                unlim_miners: "Unlimited miners",
                full_mon: "Full monitoring suite",
                dedic_supp: "24/7 dedicated support",
                unlim_users: "Unlimited users"
            },
            btn1: "Request Early Access",
            btn2: "Request Early Access",
            btn3: "Contact Sales"
        },
        faq: {
            title: "Frequently Asked Questions",
            q1: { q: "How does the pricing work?", a: "We charge a small percentage of your mining revenue based on your operation size. No monthly fees, no hidden costs. You only pay when you're mining." },
            q2: { q: "Can I try MineOps before committing?", a: "Absolutely! We offer a 30-day free trial with full access to all features. No credit card required to start." },
            q3: { q: "What mining pools do you support?", a: "We currently support only ViaBTC" },
            q4: { q: "Is my data secure?", a: "Yes. We use bank-level encryption, regular security audits, and follow industry best practices to protect your data." },
            q5: { q: "How does the rack visualization work?", a: "Our rack visualization tool allows you to create digital representations of your physical mining racks. You can drag and drop miners, see real-time status indicators, and manage your hardware layout efficiently." },
            q6: { q: "Do you offer custom integrations?", a: "Yes, our Enterprise plan includes custom integrations with your existing systems and workflows. Contact our sales team to discuss your specific requirements." }
        },
        contact: {
            title: "Get In Touch",
            subtitle: "Have questions? Our team is here to help you optimize your mining operations.",
            name: "Full Name *",
            email: "Email Address *",
            company: "Company",
            miners: "Number of Miners",
            select: "Select an option",
            msg: "Message",
            placeholder: "Tell us about your mining operation and how we can help",
            btn: "Send Message",
            success: "Thank you for your message! We'll get back to you within 24 hours.",
            error: "There was an error sending your message. Please try again or email us directly at support@mineops.com."
        },
        cta: {
            title: "Experience the Future of Mining Management",
            subtitle: "Join our exclusive BETA program today and gain instant access to our powerful unified platform.",
            placeholder: "Enter your email address",
            btn: "Join the BETA",
            success: "Welcome to the BETA! We'll be in touch with your access details shortly.",
            error: "There was an error submitting your email. Please try again.",
            reply: "We'll respond within 24 hours"
        },
        footer: {
            desc: "Professional Mining Operations Management Platform",
            doc: "Documentation",
            support: "Support",
            privacy: "Privacy Policy",
            terms: "Terms of Service",
            rights: "MineOps. All rights reserved."
        },
        cookies: {
            desc: '<i class="bi bi-cookie text-blue-400 mr-2"></i> We use cookies to improve your experience and analyze our traffic. By continuing to use our site, you consent to our use of cookies.',
            privacy: "Privacy Policy",
            decline: "Decline",
            accept: "Accept Cookies"
        }
    },
    es: {
        nav: {
            features: "Características",
            platform: "Plataforma",
            roadmap: "Futuro",
            pricing: "Precios",
            faq: "FAQ",
            contact: "Contacto",
            beta: "Solicitar Acceso a Beta",
            signin: "Ingresar"
        },
        hero: {
            badge: "¡VERSIÓN BETA DISPONIBLE! Regístrate para obtener acceso",
            title1: "<span class='word'>El</span> <span class='word'>Sistema</span> <span class='word'>Operativo</span>",
            title2: "<span class='word'>para</span> <span class='word'>Granjas</span> <span class='word'>de</span> <span class='word'>Minería</span> <span class='word highlight'>a</span> <span class='word highlight'>Escala</span> <span class='word highlight'>Industrial.</span>",
            desc: "<span class='desc-word'>Visualiza</span> <span class='desc-word'>tu</span> <span class='desc-word'>infraestructura</span> <span class='desc-word'>física</span> <span class='desc-word'>en</span> <span class='desc-word'>tiempo</span> <span class='desc-word'>real.</span> <span class='desc-word'>Automatiza</span> <span class='desc-word'>la</span> <span class='desc-word'>distribución</span> <span class='desc-word'>de</span> <span class='desc-word'>Rev-Share.</span> <span class='desc-word'>Elimina</span> <span class='desc-word'>las</span> <span class='desc-word'>hojas</span> <span class='desc-word'>de</span> <span class='desc-word'>Excel</span> <span class='desc-word'>de</span> <span class='desc-word'>tu</span> <span class='desc-word'>operación.</span>"
        },
        partnership: {
            powered: "Impulsado por",
            partner: "En asociación con"
        },
        stats: {
            val1: "+30%",
            lbl1: "Aumento de Uptime",
            val2: "500+",
            lbl2: "Sitios Gestionados",
            val3: "50K+",
            lbl3: "Mineros Monitoreados",
            val4: "24/7",
            lbl4: "Soporte en Tiempo Real"
        },
        platform: {
            title: "Tu Centro de Comando Completo",
            subtitle: "Todas las herramientas que necesitas para monitorear, gestionar y optimizar tus operaciones de minería en una única y poderosa plataforma.",
            slides: {
                dashboard: {
                    title: "Dashboard en Tiempo Real",
                    desc: "Monitorea todas tus operaciones mineras desde una interfaz única e intuitiva.",
                    f1: "Rastreo de hashrate en vivo en todas las sedes",
                    f2: "Monitoreo de estado de trabajadores (activo/inactivo)",
                    f3: "Integración con precio de Bitcoin",
                    f4: "Gráficos históricos de rendimiento",
                    f5: "Tablas desglosadas por ubicación",
                    f6: "Auto-actualización cada 10 segundos"
                },
                revshare: {
                    title: "Distribución de Ingresos (Rev-Share) en Piloto Automático.",
                    desc: "Conecta tu API de ViaBTC (Solo Lectura) y deja que MINEOPS calcule exactamente cuánto le toca a cada socio y sub-cliente. Cero errores de captura matemática, listo para facturar.",
                    f1: "Sub-cuentas automatizadas",
                    f2: "Integración nativa con ViaBTC API",
                    f3: "Elimina el error humano en cálculos",
                    f4: "Cálculos de electricidad en tiempo real",
                    f5: "Reportes listos para facturación",
                    table: {
                        partner: "Socio",
                        hashrate: "Hashrate (%)",
                        income: "Ingreso BTC",
                        status: "Estado",
                        s1: "Socio Alpha",
                        s2: "Socio Beta",
                        s3: "Inversor Fondo",
                        st_paid: "Pagado",
                        st_pending: "Pendiente",
                        rt_dist: "Distribución en Tiempo Real",
                        rt_viabtc: "Cálculos ViaBTC",
                        rt_power: "Ajuste Eléctrico"
                    }
                },
                sites: {
                    title: "Gestión Multi-Sede",
                    desc: "Vista completa de todas tus ubicaciones de minería en un solo lugar.",
                    f1: "Vistas agregadas o individuales por sede",
                    f2: "Rastreo histórico de rendimiento",
                    f3: "Distribución de trabajadores por sede",
                    f4: "Gráficos circulares de distribución de hashrate",
                    f5: "Tablas detalladas de estado de trabajadores",
                    f6: "Integración de datos de Firewall + Pool"
                },
                finance: {
                    title: "Analítica Financiera",
                    desc: "Resumen financiero completo de tus operaciones de minería.",
                    f1: "Soporte multi-divisa (BTC, USD, MXN)",
                    f2: "Seguimiento de pérdidas y ganancias",
                    f3: "Gestión de gastos por categoría",
                    f4: "Seguimiento de inversiones y ROI",
                    f5: "Análisis por intervalos de tiempo (diario a histórico)",
                    f6: "Desglose financiero por ubicación"
                }
            }
        },
        features: {
            title: "¿Por qué elegir MineOps?",
            subtitle: "La plataforma de gestión minera más completa del mercado",
            f1: { title: "Aumenta la Eficiencia", desc: "Reduce el tiempo de inactividad un 40% con monitoreo automatizado y alertas instantáneas" },
            f2: { title: "Maximiza Ganancias", desc: "Optimiza operaciones y reduce costos con decisiones basadas en datos" },
            f3: { title: "Seguridad Empresarial", desc: "Cifrado a nivel bancario y protocolos de seguridad protegen tus datos" },
            f4: { title: "Escala sin Esfuerzo", desc: "Crece de 1 a 10,000+ mineros sin perder el ritmo" }
        },
        rack: {
            title: "Personaliza los Racks de tu Granja",
            desc: "Monitorea y gestiona tus espacios disponibles en racks en tiempo real. Obtén visibilidad instantánea de todos tus sitios de minería con estadísticas exhaustivas y métricas de rendimiento.",
            f1: "Estadísticas del sitio y métricas de rendimiento en tiempo real",
            f2: "Acceso rápido a gestión de racks para cada ubicación",
            f3: "Datos agregados de hashrate y eficiencia",
            visual: {
                title: "Mapeo Físico de Racks. Encuentra fallas en 1 segundo.",
                desc: "Pasa de listas interminables a un NOC (Network Operations Center) visual. Códigos de color térmicos y de hashrate en tiempo real. Manda a tus técnicos exactamente al rack y repisa que está fallando.",
                lbl_optimal: "Óptimo:",
                st_optimal: "Funcionando correctamente.",
                lbl_warning: "Advertencia:",
                st_warning: "Bajo hashrate.",
                lbl_offline: "Desconectado:",
                st_offline: "Mal funcionamiento.",
                integration: "Se integra con la API de ViaBTC"
            }
        },
        roadmap: {
            title: "Próximamente: Futuras Implementaciones",
            subtitle: "Nuevas e increíbles funciones que estamos desarrollando para llevar tus operaciones mineras al siguiente nivel",
            badge: "Próximamente",
            f1: { title: "AI Analytics (Predicción de fallas)", desc: "Algoritmos avanzados de IA desarrollados por nuestro equipo para predecir fallas de equipos, optimizar el rendimiento y maximizar la rentabilidad." },
            f2: { title: "Alertas vía Telegram Bot", desc: "Recibe alertas instantáneas sobre tus trabajadores directo en Telegram. Entérate de caídas, problemas de temperatura y cambios en desempeño." }
        },
        pricing: {
            badge: "Precios",
            title: "Planes adaptados a tu Hashrate",
            subtitle: "Los planes se asignan automáticamente en base a tu poder de minado (PH/s). Disfruta de las mejores herramientas según el tamaño de tu operación.",
            fee: "/tarifa de minado",
            p1: { name: "Starter", desc: "Para operaciones pequeñas — precios simples y transparentes.", limit: "0 - 20 Ph/s" },
            p2: { name: "Professional", desc: "Diseñado para operaciones en crecimiento que requieren monitoreo y reportes avanzados.", limit: "20 - 50 Ph/s" },
            p3: { name: "Enterprise", desc: "Solución completa empresarial para grandes operaciones e integraciones a medida.", limit: "50 + Ph/s" },
            features: {
                basic_mon: "Monitoreo básico",
                email_supp: "Soporte por email",
                users_5: "5 usuarios incluidos",
                adv_mon: "Monitoreo avanzado",
                priority_supp: "Soporte prioritario",
                fin_reports: "Reportes financieros",
                unlim_miners: "Mineros ilimitados",
                full_mon: "Suite de monitoreo completa",
                dedic_supp: "Soporte dedicado 24/7",
                unlim_users: "Usuarios ilimitados"
            },
            btn1: "Solicitar Acceso Anticipado",
            btn2: "Solicitar Acceso Anticipado",
            btn3: "Contacta a Ventas"
        },
        faq: {
            title: "Preguntas Frecuentes",
            q1: { q: "¿Cómo funcionan los precios?", a: "Cobramos un pequeño porcentaje de tus ingresos de minería basado en el tamaño de tu operación. Sin tarifas mensuales, ni costos ocultos. Solo pagas cuando minas." },
            q2: { q: "¿Puedo probar MineOps antes de comprometerme?", a: "¡Absolutamente! Ofrecemos una prueba gratuita de 30 días con acceso a todas las características. No se requiere tarjeta de crédito para empezar." },
            q3: { q: "¿Qué pools de minería soportan?", a: "Actualmente solo soportamos ViaBTC" },
            q4: { q: "¿Están seguros mis datos?", a: "Sí. Utilizamos cifrado a nivel bancario, auditorías regulares de seguridad y seguimos las mejores prácticas de la industria para proteger tus datos." },
            q5: { q: "¿Cómo funciona la visualización de racks?", a: "Nuestra herramienta de visualización de racks te permite crear representaciones digitales de tus racks de minería físicos. Puedes arrastrar y soltar mineros, ver indicadores de estado en tiempo real y gestionar eficientemente tu diseño de hardware." },
            q6: { q: "¿Ofrecen integraciones personalizadas?", a: "Sí, nuestro plan Empresarial incluye integraciones a la medida con tus sistemas y flujos de trabajo existentes. Contacta a nuestro equipo de ventas para discutir tus requerimientos." }
        },
        contact: {
            title: "Ponte en Contacto",
            subtitle: "¿Tienes preguntas? Nuestro equipo está aquí para ayudarte a optimizar tus operaciones de minería.",
            name: "Nombre Completo *",
            email: "Correo Electrónico *",
            company: "Empresa",
            miners: "Cantidad de Mineros",
            select: "Selecciona una opción",
            msg: "Mensaje",
            placeholder: "Cuéntanos sobre tu operación minera y cómo te podemos ayudar",
            btn: "Enviar Mensaje",
            success: "¡Gracias por tu mensaje! Nos pondremos en contacto en menos de 24 horas.",
            error: "Hubo un error al enviar tu mensaje. Por favor intenta de nuevo o escríbenos directo a support@mineops.com."
        },
        cta: {
            title: "Experimenta el Futuro en la Gestión de Minería",
            subtitle: "Únete a nuestro programa BETA exclusivo hoy y obtén acceso instantáneo a nuestra potente plataforma.",
            placeholder: "Ingresa tu correo electrónico",
            btn: "Unirse a la BETA",
            success: "¡Bienvenido a la BETA! Te contactaremos con los detalles de acceso a la brevedad.",
            error: "Hubo un error enviando tu correo. Por favor, intenta de nuevo.",
            reply: "Te responderemos dentro de 24 horas"
        },
        footer: {
            desc: "Plataforma Profesional de Gestión de Operaciones Mineras",
            doc: "Documentación",
            support: "Soporte",
            privacy: "Política de Privacidad",
            terms: "Términos de Servicio",
            rights: "MineOps. Todos los derechos reservados."
        },
        cookies: {
            desc: '<i class="bi bi-cookie text-blue-400 mr-2"></i> Usamos cookies para mejorar tu experiencia y analizar nuestro tráfico. Al continuar usando nuestro sitio, aceptas nuestro uso de cookies.',
            privacy: "Política de Privacidad",
            decline: "Rechazar",
            accept: "Aceptar Cookies"
        }
    }
};
